/* eslint-disable import/no-anonymous-default-export */
// @ts-nocheck
import React from 'react';
import { isReportRead } from 'models/user/selector';

// Lazy-load the entire reporting module so Vega/charting libs don't bloat the main bundle
const LazyReporting = React.lazy(() => import('./reporting'));

export default [
	{
		path: '/reporting',
		key: 'reporting',
		componentId: 'reporting',
		component: () => <LazyReporting />,
		routes: [],
		isEnabled: (state) => {
			return isReportRead(state);
		},
		title: 'Skulicity | Reporting',
		headerName: 'Reporting',
	},
];
